
import { getDateStringVN } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import _ from 'lodash'
import { GetLaiLoByPhanTramThau, GetTextTienHoi, TinhTienHoi } from "./reportTemplete";
/*
(ngày)/(tháng), Thứ…
Tên khách
MN: 2c: (tiền xác) da: (tiền xác) dx: (tiền xác) 3c: (tiền xác) 4c: (tiền xác)
Trúng: 2c: (tiền trúng) da: (tiền trúng) dx:(tiền trúng) 3c: (tiền trúng) 4c: (tiền trúng)

*/
type groupItemList = '2C' | '3C' | '4C' | 'da' | 'dx' | 'XMB'
export const templeteMau5_details: { [key: string]: groupItemList } = {
    "6Lo2c": "2C",
    "DKC": "2C",
    '6Lo3C': '3C',
    '7Lo2C': '2C',
    '7Lo3C': '3C',
    '8Lo2C': '2C',
    'DaT': 'da',
    'Dau2C': '2C',
    'Dau4C': '4C',
    'DaX': 'dx',
    'Duoi2C': '2C',
    'Duoi4C': '4C',
    'Lo2C': '2C',
    'Lo3C': '3C',
    'Lo4C': '4C',
    'XC': '3C',
    'XcDau': '3C',
    'XcDuoi': '3C',
    'Xi2': 'XMB',
    'Xi3': 'XMB',
    'Xi4': 'XMB',
}
export const templeteMau5_total = {
    message: {} as any,
    MIEN: '',
    NGAY: '',
    //Qua cò
    QuaCo: {
        '2C': 0,
        '3C': 0,
        'da': 0,
        'dx': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    Xac: {
        '2C': 0,
        '3C': 0,
        'da': 0,
        'dx': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    //Tiền thưởng
    TienTrung: {
        '2C': 0,
        '3C': 0,
        'da': 0,
        'dx': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    DiemTrung: {
        '2C': 0,
        '3C': 0,
        'da': 0,
        'dx': 0,
        '4C': 0,
        'XMB': 0,
    } as { [key: string]: number },
    GetLaiLo: function () {
        let quaCo = 0;
        let tienThuong = 0;
        Object.keys(this.QuaCo).forEach(key => {
            quaCo += this.QuaCo[key];
        })
        Object.keys(this.TienTrung).forEach(key => {
            tienThuong += this.TienTrung[key];
        })
        return quaCo - tienThuong;
    },
    GetSMS: function () {
        let sms = "";
        sms += this.MIEN + ":"
        if (this.QuaCo['2C'] != 0) {
            sms += `2C:${tienFormat(this.Xac['2C'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['2C'], 1)}n\r\n`
        }

        if (this.QuaCo['da'] != 0) {
            sms += `da:${tienFormat(this.Xac['da'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['da'], 1)}n\r\n`
        }
        if (this.QuaCo['dx'] != 0) {
            sms += `dx:${tienFormat(this.Xac['dx'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['dx'], 1)}n\r\n`
        }
        if (this.QuaCo['3C'] != 0) {
            sms += `3C:${tienFormat(this.Xac['3C'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['3C'], 1)}n\r\n`
        }
        if (this.QuaCo['4C'] != 0) {
            sms += `4C:${tienFormat(this.Xac['4C'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['4C'], 1)}n\r\n`
        }
        if (this.QuaCo['XMB'] != 0) {
            sms += `XMB:${tienFormat(this.Xac['XMB'], 1)}. `
            // sms += `${tienFormat(this.QuaCo['XMB'], 1)}n\r\n`
        }
        //tien thuong
        let tmp = ""
        if (this.TienTrung['2C'] != 0) {
            tmp += `2c=${tienFormat(this.DiemTrung['2C'], 1)}\r\n`
        }
        if (this.TienTrung['da'] != 0) {
            tmp += `da=${tienFormat(this.DiemTrung['da'], 1)}\r\n`
        }
        if (this.TienTrung['dx'] != 0) {
            tmp += `dx=${tienFormat(this.DiemTrung['dx'], 1)}\r\n`
        }
        if (this.TienTrung['3C']! + 0) {
            tmp += `3c=${tienFormat(this.DiemTrung['3C'], 1)}\r\n`
        }
        if (this.TienTrung['4C'] != 0) {
            tmp += `4c=${tienFormat(this.DiemTrung['4C'], 1)}\r\n`
        }
        if (this.TienTrung['XMB'] != 0) {
            tmp += `XMB=${tienFormat(this.DiemTrung['XMB'], 1)}\r\n`
        }
        if (tmp != "") {
            sms += "\r\nTrúng:" + tmp
        }
        const laiLo = this.GetLaiLo()
        const laiLoSauPt = laiLo / 100 * (100 - this.message.phanTramThau)
        const tienHoiSauPt = TinhTienHoi(this.message)
        if (laiLo > 0) {
            sms += "\r\Lời:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            sms += "\r\Lỗ:" + GetLaiLoByPhanTramThau(laiLo, this.message.phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            sms += "\r\nHoà"
        }
        sms += "\r\n-----\r\n"
        return sms;
    }
}
export function getTongTienXac(message: any): number {
    let tongTienXac = 0;
    Object.keys(message.Xac).forEach(key => {
        tongTienXac += message.Xac[key]
    })
    return tongTienXac;
}
export function checkSameSign(number1: number, number2: number) {
    // Kiểm tra xem cả hai số đều âm hoặc dương
    if ((number1 >= 0 && number2 >= 0) || (number1 < 0 && number2 < 0)) {
        return true; // Cùng dấu
    } else {
        return false; // Khác dấu
    }
}
export function getSMSMau5(messages1: any) {
    const messages = Array.isArray(messages1) ? messages1 : (messages1 ? [messages1] : []);
    let smss: typeof templeteMau5_total[] = [];
    let ngay = ""
    let ten = ""
    let phanTramThau = 0
    messages && messages.length > 0 && messages.map((msg: any) => {
        let mien = "MN";
        if (msg.key == 1)
            mien = "MB";
        if (msg.key == 2)
            mien = "MT";

        let curSms: typeof templeteMau5_total = _.cloneDeep(templeteMau5_total);
        ngay = getDateStringVN(msg.date)
        curSms.MIEN = mien;
        curSms.message = msg
        ten = msg.contactName;
        phanTramThau = msg.phanTramThau;
        smss.push(curSms);
        msg.children && msg.children.map((group: any) => {
            group.children && group.children.map((item: any) => {
                const loaiCuocId: string = item.loaiCuocId;
                const groupId: string = templeteMau5_details[loaiCuocId];
                switch (loaiCuocId) {
                    case "6Lo2c":
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case "DKC":
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case '6Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case '7Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case '7Lo3C':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case '8Lo2C':
                        curSms.TienTrung["2C"] += item.thuong
                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case 'DaT':
                        curSms.TienTrung["da"] += item.thuong

                        curSms.QuaCo["da"] += item.quaCo
                        curSms.Xac["da"] += item.xac
                        curSms.DiemTrung["da"] += item.trung
                        break;
                    case 'Dau2C':
                        curSms.TienTrung["2C"] += item.thuong

                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case 'Dau4C':
                        curSms.TienTrung["4C"] += item.thuong

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        curSms.DiemTrung["4C"] += item.trung
                        break;
                    case 'DaX':
                        curSms.TienTrung["dx"] += item.thuong

                        curSms.QuaCo["dx"] += item.quaCo
                        curSms.Xac["dx"] += item.xac
                        curSms.DiemTrung["dx"] += item.trung
                        break;
                    case 'Duoi2C':
                        curSms.TienTrung["2C"] += item.thuong

                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case 'Duoi4C':
                        curSms.TienTrung["4C"] += item.thuong

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        curSms.DiemTrung["4C"] += item.trung
                        break;
                    case 'Lo2C':
                        curSms.TienTrung["2C"] += item.thuong

                        curSms.QuaCo["2C"] += item.quaCo
                        curSms.Xac["2C"] += item.xac
                        curSms.DiemTrung["2C"] += item.trung
                        break;
                    case 'Lo3C':
                        curSms.TienTrung["3C"] += item.thuong

                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case 'Lo4C':
                        curSms.TienTrung["4C"] += item.thuong

                        curSms.QuaCo["4C"] += item.quaCo
                        curSms.Xac["4C"] += item.xac
                        curSms.DiemTrung["4C"] += item.trung
                        break;
                    case 'XC':
                        curSms.TienTrung["3C"] += item.thuong

                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case 'XcDau':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case 'XcDuoi':
                        curSms.TienTrung["3C"] += item.thuong
                        curSms.QuaCo["3C"] += item.quaCo
                        curSms.Xac["3C"] += item.xac
                        curSms.DiemTrung["3C"] += item.trung
                        break;
                    case 'Xi2':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        curSms.DiemTrung["XMB"] += item.trung
                        break;
                    case 'Xi3':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        curSms.DiemTrung["XMB"] += item.trung
                        break;
                    case 'Xi4':
                        curSms.TienTrung["XMB"] += item.thuong
                        curSms.QuaCo["XMB"] += item.quaCo
                        curSms.Xac["XMB"] += item.xac
                        curSms.DiemTrung["XMB"] += item.trung
                        break;
                    default:
                        console.log('Bổ xung loại cược mới', loaiCuocId)
                }
            })
        })
    })
    let zSms = "Ngày:" + ngay + ". " + ten + "\r\n"
    let laiLo = 0;
    let tienHoiSauPt = 0;
    let tongTienXac = 0;
    smss.forEach(sms => {
        zSms += sms.GetSMS()
        laiLo += sms.GetLaiLo()
        tienHoiSauPt += TinhTienHoi(sms.message)
        tongTienXac += getTongTienXac(sms)
    })
    const laiLoSauPt = laiLo / 100 * (100 - phanTramThau)
    //if (messages.length > 1) {
        let caiText = ""
        if (checkSameSign(laiLoSauPt, tongTienXac))
            caiText = "Cái lời:"
        else
            caiText = "Cái lỗ:"
        if (laiLoSauPt > 0) {
            zSms += `\r\n${caiText}` + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else if (laiLo < 0) {
            zSms += `\r\n${caiText}` + GetLaiLoByPhanTramThau(laiLo, phanTramThau) + GetTextTienHoi(laiLoSauPt, tienHoiSauPt)
        } else {
            zSms += "\r\nCái hoà"
        }
    //}
    console.log(zSms)
    return zSms;
}